import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('power-button', '0 0 96 96', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M42.8 1h10.4v52.2H42.8z" }),
    React.createElement("path", { d: "M78.4 12.3L71 19.7c8.3 6.6 13.5 16.8 13.5 28.3 0 20.2-16.3 36.6-36.6 36.6S11.4 68.2 11.4 48c0-11.4 5.3-21.6 13.5-28.3l-7.4-7.4C7.4 20.9 1 33.7 1 48c0 26 21 47 47 47s47-21 47-47c0-14.3-6.4-27.1-16.6-35.7z" })));
